import React from 'react';
import { Modal } from 'react-bootstrap';
import { BSModal } from '~/components/Bootstrap';
import { useRoleActions } from '~/util/useRoleActions';
import { enumValue } from '~/util';
import { ClientContext } from '~/services';

interface MediaPreviewProps {
    children?: JSX.Element;
    media: {
        id: number | string;
        // eslint-disable-next-line babel/camelcase
        original_filename: string;
    };
    gapType?: null | number;
    isEditing?: boolean;
}
function MediaPreview({ children, media, gapType = null, isEditing = false }: MediaPreviewProps) {
    const { reportYear } = React.useContext(ClientContext);
    const [show, setShow] = React.useState(false);
    let role = '';
    switch (gapType) {
        case enumValue(['gap', 'type', 'Risk Gap']):
            role = 'allow_view_attachments_risk_gaps';
            break;
        case enumValue(['gap', 'type', 'FOC Gap']):
            role = 'allow_view_attachments_foc_gaps';
            break;
        case enumValue(['gap', 'type', 'Quality Gap']):
            role = 'allow_view_attachments_quality_gaps';
            break;
        default:
            break;
    }
    const canShow = useRoleActions(role);

    function showPreview() {
        setShow(true);
    }

    function hidePreview() {
        setShow(false);
    }

    return canShow && !isEditing ? (
        <>
            <button type="button" className="link-button" onClick={showPreview} disabled={show}>
                <div className="text-ellipsis">{children || media.original_filename}</div>
            </button>
            <BSModal
                className="preview-modal"
                show={show}
                onHide={hidePreview}
                aria-labelledby="media-preview-title"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="media-preview-title" role="heading" aria-level={1}>
                        Preview Upload
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <object
                        data={`/api/media/${media.id}/view?report_year=${reportYear}#toolbar=0`}
                        type="application/pdf"
                        className="media-preview-size"
                        aria-label="Media Preview"
                    >
                        <embed
                            id="lr-media-preview-pdf-embed"
                            src={`/api/media/${media.id}/view?report_year=${reportYear}#toolbar=0`}
                            type="application/pdf"
                            className="media-preview-size"
                        />
                    </object>
                </Modal.Body>
            </BSModal>
        </>
    ) : (
        <div>{children || media.original_filename}</div>
    );
}

export { MediaPreview };
